package meineglasfaser.frontend.common.components.widgets

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun ErrorCard(
    errorText: String?,
) {
    if (!errorText.isNullOrBlank()) {
        Div(attrs = { classes("card", "error") }) {
            P {
                Text(errorText)
            }
        }
    }
}
